const content = [require("./1/index").default];

export default content;
